// Keep in sync with the backend's UPLOAD_MAX_BYTES (app/core/config.py).
// A real phone photo / ID scan is typically 3-12MB, so this is generous enough
// to accept them while still stopping an accidental huge file before it's sent.
export const MAX_UPLOAD_MB = 15;
const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

/**
 * Returns a human-readable error if the file is too big to upload, else null.
 * Catch this BEFORE submitting so the user gets a clear "too large" message and
 * can pick a smaller file, instead of a confusing failure after the fact.
 */
export function fileTooLargeError(file: File | null, label: string): string | null {
  if (!file) return null;
  if (file.size > MAX_UPLOAD_BYTES) {
    const mb = (file.size / (1024 * 1024)).toFixed(1);
    return `${label} is too large (${mb}MB). Max ${MAX_UPLOAD_MB}MB — please choose a smaller image.`;
  }
  return null;
}
